import { jsx as n, jsxs as T, Fragment as $ } from "react/jsx-runtime";
import { createContext as j, forwardRef as i, useState as D, useEffect as F, useCallback as M, useMemo as P, useContext as x } from "react";
import { faTimes as R, faCircleCheck as B, faExclamationTriangle as S, faInfoCircle as q, faExclamationCircle as z } from "@fortawesome/pro-regular-svg-icons";
import { faInfoCircle as G, faCircleCheck as H, faExclamationCircle as J, faExclamationTriangle as K } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import { Button as L } from "../button/Button.js";
import { twMerge as s } from "tailwind-merge";
const f = j({
  type: "success",
  variant: "outline",
  close: () => {
  }
}), O = i(
  ({
    type: o,
    variant: t = "outline",
    children: e,
    onClose: c,
    isClosed: r,
    closable: a = !1,
    className: l,
    ...b
  }, w) => {
    const [h, m] = D(r || !1);
    F(() => {
      r && m(r);
    }, [r]);
    const u = M(
      (E) => {
        r || m(!0), c && c(E);
      },
      [r, c]
    ), y = P(
      () => ({ type: o, variant: t, close: u }),
      [o, t, u]
    );
    if (h)
      return null;
    const { border: A, background: v, text: I } = g(o, t);
    return /* @__PURE__ */ n(f.Provider, { value: y, children: /* @__PURE__ */ n(
      "div",
      {
        className: s(
          "flex flex-row items-start gap-3 rounded-md border p-3",
          I,
          A,
          v,
          l
        ),
        ref: w,
        ...b,
        children: typeof e == "string" ? /* @__PURE__ */ T($, { children: [
          /* @__PURE__ */ n(p, {}),
          /* @__PURE__ */ n(C, { children: /* @__PURE__ */ n(k, { children: e }) }),
          a && /* @__PURE__ */ n(N, {})
        ] }) : e
      }
    ) });
  }
), C = i(
  ({ className: o, ...t }, e) => /* @__PURE__ */ n("div", { ref: e, className: s("flex flex-grow flex-col gap-0.5", o), ...t })
), k = i(
  ({ className: o, ...t }, e) => {
    const { type: c, variant: r } = x(f), { text: a } = g(c, r);
    return /* @__PURE__ */ n("p", { ref: e, className: s("text-sm font-medium", a, o), ...t });
  }
), Q = i(
  ({ className: o, ...t }, e) => {
    const { type: c, variant: r } = x(f), { text: a } = g(c, r);
    return /* @__PURE__ */ n("p", { ref: e, className: s("text-sm font-normal", a, o), ...t });
  }
), p = i(
  ({ className: o, ...t }, e) => {
    const { type: c, variant: r } = x(f), { iconColor: a, icon: l } = g(c, r);
    return /* @__PURE__ */ n(d, { ref: e, className: s(a, o), icon: l, ...t });
  }
), N = i(
  ({ className: o, children: t, ...e }, c) => {
    const { type: r, variant: a, close: l } = x(f), { iconColor: b } = g(r, a);
    return /* @__PURE__ */ n(
      L,
      {
        variant: "none",
        onClick: l,
        className: s(b, o),
        ref: c,
        "aria-label": "Close notification",
        ...e,
        children: t || /* @__PURE__ */ n(d, { icon: R })
      }
    );
  }
), g = (o, t) => {
  const e = {
    text: "text-green-700",
    border: "border-green-300",
    background: "bg-green-25",
    iconColor: "text-green-500",
    icon: B
  };
  if (t === "solid")
    switch (e.text = "text-gray-900", e.border = "border-none", o) {
      case "warning":
        e.background = "bg-warning-50", e.iconColor = "text-warning-700", e.icon = K;
        break;
      case "error":
        e.background = "bg-error-50", e.iconColor = "text-error-700", e.icon = J;
        break;
      case "success":
        e.background = "bg-success-50", e.iconColor = "text-success-700", e.icon = H;
        break;
      case "info":
      default:
        e.background = "bg-gray-50", e.iconColor = "text-gray-700", e.icon = G;
        break;
    }
  else
    switch (o) {
      case "error":
        e.text = "text-red-700", e.border = "border-red-300", e.background = "bg-red-25", e.iconColor = "text-red-500", e.icon = z;
        break;
      case "info":
        e.text = "text-gray-700", e.border = "border-gray-300", e.background = "bg-white", e.iconColor = "text-gray-500", e.icon = q;
        break;
      case "warning":
        e.text = "text-orange-700", e.border = "border-orange-500", e.background = "bg-orange-25", e.iconColor = "text-orange-500", e.icon = S;
        break;
    }
  return e;
}, ee = O, oe = C, te = k, re = Q, ne = p, ce = N;
export {
  O as AlertNotification,
  N as AlertNotificationClose,
  C as AlertNotificationContent,
  f as AlertNotificationContext,
  Q as AlertNotificationDescription,
  p as AlertNotificationIcon,
  k as AlertNotificationTitle,
  ce as Close,
  oe as Content,
  re as Description,
  ne as Icon,
  ee as Root,
  te as Title
};
